enum SlotState {
  ENABLED = 'enabled',
  DISABLED = 'disabled',
}

interface Slot {
  default_travel_time_seconds: number;
  slot_number?: number;
  tray_number?: number;
  state: SlotState;
  is_faulty: boolean;
  id?: string;
}

enum SlotType {
  FIXED_CONTAINER = 'fixed_container_slots',
  MOBILE_CONTAINER = 'mobile_container_slots',
  COOKING_UNIT = 'cooking_units',
  PLATE_STAND = 'plate_stands',
  LOCKER = 'locker_slots',
  ROBOT_TRAY = 'robot_trays'
}

interface KitchenConfiguration {
  mobile_container_slots: Slot[];
  fixed_container_slots: Slot[];
  cooking_units: Slot[];
  plate_stands: Slot[];
  locker_slots: Slot[];
  robot_trays: Slot[];
}

const getInitialEnabledSlotNumbers = (slotType: SlotType) => {
  switch (slotType) {
    case SlotType.FIXED_CONTAINER:
      return 49;
    case SlotType.MOBILE_CONTAINER:
      return 30;
    case SlotType.COOKING_UNIT:
      return 6;
    case SlotType.PLATE_STAND:
      return 2;
    case SlotType.LOCKER:
      return 6;
    case SlotType.ROBOT_TRAY:
      return 2;
    default:
      return 1;
  }
}



const SLOT_TYPES_WITH_IS_FAULTY = [
  SlotType.FIXED_CONTAINER,
  SlotType.MOBILE_CONTAINER,
  SlotType.COOKING_UNIT,
  SlotType.PLATE_STAND,
  SlotType.ROBOT_TRAY,
];

const getInitialSlots = (slotType: SlotType, kitchenConfigurationOptions) => {
  const maxEnabledSlotNumber = getInitialEnabledSlotNumbers(slotType);
  const totalSlots = kitchenConfigurationOptions[slotType].rows * kitchenConfigurationOptions[slotType].columns;
  return Array.from({ length: totalSlots }, (_, index) => {
    const numberField = slotType === SlotType.ROBOT_TRAY ? 'tray_number' : 'slot_number';
    const slot: Partial<Slot> = {
      [numberField]: index + 1,
      state: (index + 1 <= maxEnabledSlotNumber) ? SlotState.ENABLED : SlotState.DISABLED,
    };
    if (SLOT_TYPES_WITH_IS_FAULTY.includes(slotType)) {
      slot.is_faulty = false;
    }
    return slot;
  });
}

const newlyDisabledCookingUnitSlotNumbers = (currentUnits: Slot[], initialUnits: Slot[]): number[] =>
  currentUnits
    .filter((unit) => {
      if (unit.state !== SlotState.DISABLED) return false

      const initialUnit = initialUnits.find((initial) => initial.id === unit.id)
      return initialUnit?.state === SlotState.ENABLED
    })
    .map((unit) => unit.slot_number)
    .filter((slotNumber): slotNumber is number => slotNumber != null)

export {
  SlotState, Slot, SlotType, KitchenConfiguration, getInitialSlots, SLOT_TYPES_WITH_IS_FAULTY,
  newlyDisabledCookingUnitSlotNumbers
}
